/* Qfinita age declaration v1.0. Theme declaration, not identity verification. */
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const replay = new WeakSet();
  const pending = new WeakSet();
  let resolvePrompt = null;
  let previousFocus = null;
  function dateError(day, month, year, today = new Date()) {
    if (![day, month, year].every(Number.isInteger) || year < 1900 || month < 1 || month > 12 || day < 1 || day > 31) return 'Please enter a valid date of birth.';
    const birth = new Date(year, month - 1, day);
    if (birth.getFullYear() !== year || birth.getMonth() !== month - 1 || birth.getDate() !== day || birth > today) return 'Please enter a valid date of birth.';
    let age = today.getFullYear() - year;
    if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) age--;
    return age < 18 ? 'You must be aged 18 or over to purchase this product.' : '';
  }
  function finish(accepted) {
    const dialog = document.getElementById('qfinita-age-dialog');
    const callback = resolvePrompt;
    resolvePrompt = null;
    dialog.close();
    document.getElementById('qfinita-age-form').reset();
    previousFocus?.focus();
    callback?.(accepted);
  }
  function prompt(checkout) {
    if (resolvePrompt) return Promise.resolve(false);
    const dialog = document.getElementById('qfinita-age-dialog');
    const form = document.getElementById('qfinita-age-form');
    form.reset();
    document.getElementById('qfinita-age-title').textContent = checkout ? 'Age-restricted item in your basket' : 'Age-restricted product';
    document.getElementById('qfinita-age-description').textContent = checkout
      ? 'An item in your basket is age restricted. Please re-enter your date of birth to confirm your age. Please note: all orders containing age-restricted products are manually reviewed by our team, and orders may be subject to further age verification.'
      : 'You must be aged 18 or over to purchase this product. Please enter your date of birth and confirm the declaration below.';
    document.getElementById('qfinita-age-error').textContent = '';
    document.getElementById('qfinita-age-confirm').textContent = checkout ? 'Confirm and continue to checkout' : 'Confirm and add to basket';
    previousFocus = document.activeElement;
    return new Promise((resolve) => {
      resolvePrompt = resolve;
      dialog.showModal();
      form.elements.day.focus();
    });
  }
  const dialog = document.getElementById('qfinita-age-dialog');
  if (!dialog) return;
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); finish(false); });
  dialog.querySelector('.qfinita-age-cancel').addEventListener('click', () => finish(false));
  document.getElementById('qfinita-age-form').addEventListener('submit', (event) => {
    event.preventDefault();
    const fields = event.currentTarget.elements;
    const error = dateError(Number(fields.day.value), Number(fields.month.value), Number(fields.year.value));
    document.getElementById('qfinita-age-error').textContent = error || (!fields.declaration.checked ? 'Please tick the declaration to confirm that you are aged 18 or over.' : '');
    if (!error && fields.declaration.checked) finish(true);
  });
  function addProperty(form, name, value) {
    let input = Array.from(form.elements).find((field) => field.name === name);
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
    input.value = value;
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  async function checkCheckout() {
    const response = await fetch(`${root}cart?view=qfinita-age&_=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart check failed');
    const data = JSON.parse(await response.text());
    if (typeof data.restricted !== 'boolean') throw new Error('Invalid cart check');
    if (!data.restricted) return true;
    if (!(await prompt(true))) return false;
    const saved = await fetch(`${root}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ attributes: { '18+ declaration': 'Accepted by purchaser', 'Age declaration date': new Date().toISOString() } })
    });
    if (!saved.ok) throw new Error('Declaration could not be saved');
    return true;
  }
  function reportFailure() { window.alert('We could not complete the age declaration check. Please try again.'); }
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (replay.has(form)) { replay.delete(form); return; }
    const isAdd = form.querySelector('[data-qfinita-age-required="true"]');
    const isCheckout = event.submitter?.name === 'checkout';
    if (!isAdd && !isCheckout) return;
    stop(event);
    if (pending.has(form)) return;
    pending.add(form);
    const submitter = event.submitter;
    try {
      const accepted = isAdd ? await prompt(false) : await checkCheckout();
      if (!accepted || !form.isConnected) return;
      if (isAdd) {
        addProperty(form, 'properties[18+ declaration]', 'Accepted by purchaser');
        addProperty(form, 'properties[Age declaration date]', new Date().toISOString());
      }
      replay.add(form);
      form.requestSubmit(submitter && submitter.isConnected ? submitter : undefined);
    } catch (error) { reportFailure(); }
    finally { pending.delete(form); replay.delete(form); }
  }, true);
  // Check checkout links and button clicks before other theme handlers run.
  const allowedClicks = new WeakSet();
  document.addEventListener('click', async (event) => {
    const control = event.target.closest?.('button[name="checkout"],input[name="checkout"],a[href]');
    if (!control) return;
    const checkoutLink = control.tagName === 'A' && /\/checkout\/?$/.test(new URL(control.href, location.href).pathname);
    if (control.name !== 'checkout' && !checkoutLink) return;
    if (control.disabled) return;
    if (allowedClicks.has(control)) { allowedClicks.delete(control); if (control.form) replay.add(control.form); return; }
    stop(event);
    if (pending.has(control)) return;
    pending.add(control);
    try {
      if (!(await checkCheckout()) || !control.isConnected) return;
      if (checkoutLink) location.assign(control.href);
      else { allowedClicks.add(control); control.click(); }
    } catch (error) { reportFailure(); }
    finally { pending.delete(control); allowedClicks.delete(control); if (control.form) replay.delete(control.form); }
  }, true);
})();
